import FontAwesomeIcon from './fontawesome'

const loadPlugins = function () {
	return { FontAwesomeIcon }
}

export { loadPlugins }



